/** API REDUCER */

import API from 'helpers/api';

export const getToken = () => API.getFirebaseToken();

/**
 * `fetchInventoryTable` lived here and was the last caller of audit-functions'
 * `/api/analytics/sites/:siteKey/inventory`, which has been removed along with the rest of that
 * service's HTTP surface.
 *
 * Nothing was lost. The action wrote its result to `table.inventory`, and **no component ever read
 * that slice** — so the request fetched data into the store and dropped it. Its only real caller was
 * `SitesManager`, and `AnalyticsController` merely mapped it into props without ever invoking it. The
 * page that rendered the inventory widgets (`pages/analytics/inventory.jsx`) was not routed either:
 * both route files declared an `AnalyticsInventoryPage` loadable that nothing referenced, while
 * `/analytics/inventory` resolves to `AnalyticsStockAuditPage`, which is untouched.
 *
 * The reducer itself stays: ~8 analytics chart components map `api: state.api`, so the slice must
 * keep existing with its shape intact even though nothing dispatches into it any more.
 */
const initialState = {
	table: {
		_loading: false,
		sites: null,
		sitesIssues: null,
		issues: null,
		issuesQuestions: null,
		auditors: null,
	},
};

export const apiReducer = (state = initialState) => state;
